import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export default function WelcomePage() {
  const navigate = useNavigate();

  const handleBegin = () => {
    navigate("/gate");
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <div className="relative min-h-[65vh] flex flex-col">
        {/* Background Image */}
        <img
          src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1920&q=80"
          alt="Mediterranean coastline"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ filter: "brightness(0.94) saturate(0.88)" }}
        />
        
        {/* Refined overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-transparent to-background z-[1]" />

        {/* Fixed Logo - Top Center */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="absolute top-0 left-0 right-0 z-20 pt-8 md:pt-10"
        >
          <div className="text-center">
            <span className="brand-logo brand-logo-small text-foreground">
              Charles Marlow
            </span>
          </div>
        </motion.div>

        {/* Hero Content */}
        <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-8 pt-20 pb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="text-center max-w-lg"
          >
            <h1 className="heading-display text-3xl md:text-4xl text-foreground leading-snug mb-10">
              Plan your stay with thoughtful, locally led support
            </h1>

            <button
              onClick={handleBegin}
              data-testid="begin-btn"
              className="btn-primary max-w-[240px] mx-auto"
            >
              Begin
            </button>
          </motion.div>
        </div>
      </div>

      {/* Why Book Section - Editorial Style */}
      <section className="editorial-section">
        <div className="px-8 md:px-12 lg:px-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="text-center"
          >
            <h2 className="editorial-heading">
              Why book through My World VIP
            </h2>
            
            <div className="editorial-body">
              <p>
                My World VIP is Charles Marlow's trusted concierge partner of 10 years, specialising in thoughtful, locally-led support that makes time on the island effortless. From trusted transfers and chefs to experiences that go beyond the obvious, our team works with a carefully vetted network of suppliers to ensure quality, reliability and seamless coordination.
              </p>
              
              <p>
                Booking through My World VIP means expert recommendations, transparent communication, island knowledge, and a single point of contact who understands both your villa and your plans, so everything runs smoothly before you arrive and throughout your stay.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Subtle Footer */}
      <div className="bg-background py-10">
        <div className="text-center">
          <a
            href="/admin"
            data-testid="admin-link"
            className="text-xs tracking-widest text-muted-foreground/30 hover:text-muted-foreground/50 transition-colors"
          >
            ADMIN
          </a>
        </div>
      </div>
    </div>
  );
}
